// The storyteller's weekly journal. Add new entries at the TOP of the array.
// Each post supports an optional image and/or videoUrl (YouTube, Vimeo, or .mp4 link).
export const JOURNAL_POSTS = [
  {
    id: "the-weight-we-carry",
    title: "The Weight We Carry Isn't Meant to Be Carried Alone",
    date: "2026-06-14",
    category: "Weekly Reflection",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1498550744921-75f79806b8a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxwZWFjZWZ1bCUyMGNhbG0lMjBuYXR1cmUlMjBkYXdufGVufDB8fHx8MTc5MjIxNTQ0Nnww&ixlib=rb-4.1.0&q=85",
    videoUrl: "",
    excerpt: "Some weeks the hardest, bravest thing we do is simply stay. This is a note for anyone who made it through a heavy one.",
    body: [
      "I've been telling stories my whole life — around kitchen tables, in quiet hospital rooms, on stages where I never expected to stand. And if there's one truth I keep coming back to, it's this: the weight we carry was never meant to be carried alone.",
      "This week I spoke with someone who told me they almost didn't make it. And then they did. They stayed. Not because the pain vanished, but because one person reached back when they reached out.",
      "If that's you right now — if you're reading this with a heavy heart — I want you to know you are not a burden. You are a story still being written, and the world is better with your chapter in it.",
      "Reach for someone. Call or text 988. Let today be the day you let a little light in.",
    ],
  },
  {
    id: "stay-the-song",
    title: "A Song Called 'Stay' Is Coming",
    date: "2026-06-07",
    category: "Behind the Music",
    readTime: "3 min read",
    image: "https://static.prod-images.emergentagent.com/jobs/75b9c5c6-532e-431d-9882-59e81d3325d2/images/1f19b7d9b508a5aff244eccd4ddd04d0960cdb9e70f56cb5bf773acf84d2a458.jpeg",
    videoUrl: "",
    excerpt: "I wrote a song for everyone standing at the edge of a hard decision. It's called 'Stay,' and it arrives January 2027.",
    body: [
      "Months ago, I sat down with nothing but a melody and a prayer. What came out was a song I couldn't shake — a gentle, stubborn plea to anyone who's hurting: stay.",
      "'Stay' was written for suicide prevention. Every word is meant to be a hand on a shoulder, a reminder that tomorrow still has something for you.",
      "We're releasing it in January 2027, and I can't wait for you to hear it. Until then, let the title be the message: Stay.",
    ],
  },
];
